// extracted by mini-css-extract-plugin
module.exports = {"anchor":"LinkContainer_anchor__bOj_o"};